export default function valueContainerStyle() {
  return (styles) => ({
    ...styles,
    float: 'left',
    paddingRight: '31px'
  });
}
